export default {
  title: 'Leveringspartnere',
};
